<button class="dashed-container-button" (click)="buttonClick.emit()">
  <h2>Create your first {{ type | lowercase }}</h2>
  <div class="create">Create {{ type | titlecase }}</div>
</button>
